export default __webpack_public_path__ + "static/media/6.4bda5926.png";